import styled from '@emotion/styled';
import background from '../../assets/moa-login-pattern.jpg';
import { StyledProps } from '../../components/Button/Button.types';
import rem from '../../utils/rem/rem';

export const StyledContainer = styled.main`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url(${background});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100%;
  margin: ${rem(0)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    height: 25vh;
  }
`;

export const LogoWrapper = styled.div`
  height: ${rem(242)};
  width: ${rem(611)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    height: ${rem(100)};
    width: ${rem(300)};
  }
`;

export const LoginCard = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  width: 45%;

  button {
    margin: ${rem(16)};

    @media ${({ theme }) => theme.breakpoints.sm} {
      font-size: ${rem(14)};
      padding: ${rem(0)} ${rem(16)};
    }
  }
`;

export const Title = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(35)};
  text-align: center;
  padding: ${rem(32)} ${rem(20)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: ${rem(23)};
    padding: ${rem(32)} ${rem(0)} ${rem(0)} ${rem(0)};
  }
`;
